module.exports = __webpack_public_path__ + "img/list_nothing.2f890e00.png";